import PropTypes from 'prop-types';
import { useMemo } from 'react';
import Tooltip from '../../Atoms/Tooltip';

/*
#tailwind
*/

const Emoji = ({ shortcode, emoticon, emoji, ...other }) => {
  const toolTipContent = useMemo(() => shortcode ?? emoticon, [shortcode, emoticon]);
  return <span {...other}>{toolTipContent ? <Tooltip content={toolTipContent}>{emoji}</Tooltip> : emoji}</span>;
};

Emoji.propTypes = {
  shortcode: PropTypes.string,
  emoticon: PropTypes.string,
  emoji: PropTypes.string.isRequired,
};

Emoji.defaultProps = {
  shortcode: undefined,
  emoticon: undefined,
};

export default Emoji;
